angular.module('SpidApp')

.directive('circularCode',
        ['$document', '$timeout', '$rootScope', 'BarcodeScanner',
function( $document,   $timeout,   $rootScope,   BarcodeScanner) {

  var currentCode = []
  var timeoutPromise = null

  return {
    restrict: 'A',
    link: function(scope, element, attr) {

      if (!attr.circularCode) {
        throw('CircularCode (directive) - "circular-code" attribute should be a valid expression')
      }

      var resetCode = function () {
        currentCode = []
      }

      var keydown = function (e) {
        currentCode.push( String.fromCharCode(e.keyCode) )

        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise)
        }

        timeoutPromise = $timeout(function () {
          BarcodeScanner.set(currentCode.join(''))
          resetCode()

          $rootScope.$broadcast('circularCodeAvailable')

          timeoutPromise = null
        }, 100)
      }

      $document.on('keydown', keydown)

      $rootScope.$on('$destroy', function () {
        $document.off('keydown', keydown)
      })
    }
  }

}])
